<template>
  <div>
    <div class="inner-content">
      <h2>{{ $t('configuration') }}</h2>
      <div class="setting-browse clearfix">
        <p class="setting-browse-txt">
          {{ $t('list_patients_who_have_been_viewed') }}
        </p>
        <div class="toggle-switch">
          <input type="checkbox" :checked="patientHistoriesFlg" id="browse-switch" @click="toggleSetting()" />
          <label for="browse-switch" />
        </div>
      </div>
      <div class="setting-browse clearfix" style="margin-top: 16px">
        <p class="setting-browse-txt">
          2段階認証を有効にする
        </p>
        <div class="toggle-switch mb30">
          <input type="checkbox" id="mfa-switch" :checked="enabled2FA" @click="mfaSwitch()" />
          <label for="mfa-switch" />
        </div>
        <p class="mb10">
          2段階認証用電話番号
        </p>
        <div style="display: flex;">
          <input
          type="text"
          class="change-phone-number"
          v-model="attributeUser.user_phone_number"
          readonly
          />
          <div class="change-phone-number-btn"><a href="javascript:;" @click="$router.push('/register-phone-number')"
              style="color: white;font-weight: 600;">
              <p style="margin-top: 10px;">変更</p>
            </a>
          </div>
        </div>
      </div>
      <div class="setting-browse clearfix" style="margin-top: 16px">
        <p class="setting-browse-txt" style="margin-top: 10px;">
          メールアドレスを変更する
        </p>
        <div style="display: flex;">
          <div class="onetime-btn-base"><a href="javascript:;" @click="changeEmail()"
              style="color: white;font-weight: 600;">
              <p style="margin-top: 10px;">変更する</p>
            </a></div>
        </div>
      </div>
      <Spinner :isLoading="isLoading" />
    </div>
    <template v-if="$store.state.auth.typeOfUser === 'doctor'">
      <SurveyBanner />
    </template>

    <div id="modal">
      <b-modal id="mfa-warning" centered :hide-header="true" :hide-footer="true" class="modal-content">
        <div class="modal-inner">
          <p class="modal-ttl">2段階認証をONにしました</p>
          <p class="modal-txt-error mb50">
            次回ログインするタイミングから登録した電話番号に認証コードが <br>
            送信され、IDとパスワードに加えて認証コードを入力してログインします。
          </p>
          <p class="modal-txt-error mb50" style="color: red;">nana-mediにも同様の設定が反映されます。</p>
          <div class="btn-base pos-center"><a href="javascript:;" class="modal-close"
              @click="$bvModal.hide('mfa-warning')">
              <p>{{ $t('ok') }}</p>
            </a>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import Spinner from "@/js/components/Spinner"
import SurveyBanner from '@/js/components/Common/SurveyBanner'
import { mapState } from 'vuex'
import { BModal, VBModal, BButton } from 'bootstrap-vue'
export default {
  components: {
    Spinner, SurveyBanner
  },
  mounted() {
    this.screenTracking(this.$t('configuration'))
  },
  computed: {
    patientHistoriesFlg() {
      const flg = this.$store.state.auth.doctorInfo.patient_histories_flg
      return (!flg || flg === 0) ? false : true
    },
    ...mapState({
      updateDoctorErr: state => state.auth.updateDoctorErr,
      access_token: (state) => state.auth.access_token,
      attributeUser: (state) => state.auth.attributeUser,
      isFirstTimeRegisterPhone: (state) => state.auth.isFirstTimeRegisterPhone,
    })
  },
  data() {
    return {
      isLoading: false,
      enabled2FA: false,
    }
  },
  async mounted() {
    await this.$store.dispatch("auth/getAttributeUser", { access_token: this.access_token })
    if (this.isFirstTimeRegisterPhone && this.attributeUser.user_MFA_setting) {
      this.enabled2FA = true
      this.$bvModal.show('mfa-warning')
      this.$store.dispatch('auth/setDefaultFirstTimeRegisterPhone')
    } else {
      this.enabled2FA = this.attributeUser.user_MFA_setting
    }
  },
  methods: {
    async toggleSetting() {
      let side_text = document.getElementsByClassName('side-txt')
      let ml_w = document.getElementById('m-left-col')
      const flg = this.$store.state.auth.doctorInfo.patient_histories_flg
      const patient_histories_flg = (!flg || flg === 0) ? 1 : 0
      const event = {
        event: this.$t('configuration'),
        event_category: this.$t('configuration'),
        event_label: patient_histories_flg === 0 ? this.$t('patient_list_off') : this.$t('patient_list_on')
      }
      this.eventTracking(event)
      this.isLoading = true
      const params = {
        patient_histories_flg
      }
      await this.$store.dispatch('auth/updateDoctor', params)
      if (ml_w.offsetWidth === 60) {
        Array.from(side_text).forEach(function (item) {
          item.style.display = 'none'
        })
      }
      this.isLoading = false
    },
    async mfaSwitch() {
      this.enabled2FA = this.attributeUser.user_MFA_setting
      if (!this.attributeUser.phone_number) {
        this.$router.push('/register-phone-number')
      } else {
        this.enabled2FA = this.enabled2FA ? false : true
        const params = {
          access_token: this.access_token,
          flag: this.enabled2FA,
          isFirstTimeRegisterPhone: false
        }
        this.isLoading = true
        await this.$store.dispatch("auth/setMFA", params)
        await this.$store.dispatch("auth/getAttributeUser", { access_token: this.access_token })
        this.isLoading = false
        if (this.enabled2FA) {
          this.$bvModal.show('mfa-warning')
        }
      }
    },
    changeEmail() {
      this.$router.push('/change-email')
    }
  },
  directives: { BModal, VBModal, BButton },
};
</script>
<style scoped>
.onetime-btn-base {
  font-size: 1.0rem;
  text-align: center;
  width: 190px;
  height: 40px;
  box-sizing: border-box;
  background: #ffa300;
}
.change-phone-number {
  box-sizing: border-box;
  width: 400px;
  padding: 6px;
  border: 1px solid #ff9fae;
  margin-right: 20px;
}
.change-phone-number-btn {
  font-size: 1.0rem;
  text-align: center;
  width: 70px;
  height: 40px;
  box-sizing: border-box;
  background: #ffa300;
}
</style>